import * as OmniDataModel from "./omniDataModel";

import { v4 as uuid } from "uuid";

export const tempMethodMigratePersonToUser = person => {
  try {
    //the parameter is a demo, we have to blend it with the latest.

    let odmo = OmniDataModel.createNewUser(true);

    odmo = { ...odmo, ...person }; //magic

    odmo.omniData.displayName = person.user.name;
    odmo.omniData.nameTitle = person.user.title;
    odmo.omniData.givenName = person.user.givenName;
    odmo.omniData.middleName = person.user.middleName;
    odmo.omniData.familyName = person.user.familyName;
    odmo.omniData.nameSuffix = "";
    odmo.omniData.mobilePhone = person.user.phone;
    odmo.omniData.email = person.user.email;
    odmo.omniData.address = person.user.address = {
      streetAddress: person.user.address.streetAddress,
      locality: person.user.address.locality,
      region: person.user.address.region,
      postalCode: person.user.address.postalCode,
      cournty: person.user.address.country,
    };

    odmo.omniData.patientData.gender = person.user.gender;
    odmo.omniData.patientData.race = person.user.race;
    odmo.omniData.patientData.ethnicity = person.user.ethnicity;
    odmo.omniData.patientData.countryOfBirth = person.user.countryOfBirth;
    odmo.omniData.patientData.birthdate = person.user.birthdate;
    odmo.omniData.patientData.disabilityStatus = person.clerical.disabilityStatus;
    odmo.omniData.patientData.employmentStatus = person.clerical.employmentStatus;
    odmo.omniData.patientData.financialAssistance = person.clerical.financialAssistance;

    return odmo;
  } catch (error) {
    console.log("Unable to tempMethodMigratePersonToUser: " + error);
    return null;
  }
};

export const getDemoPatientODM = patientID => {
  console.log("attempting to getDemoPatientODM");

  if (patientID === "linda1") {
    return tempMethodMigratePersonToUser(linda1);
  }
  if (patientID === "linda2") {
    return tempMethodMigratePersonToUser(linda2);
  }
  if (patientID === "linda3") {
    return tempMethodMigratePersonToUser(linda3);
  }
  if (patientID === "mae1") {
    return tempMethodMigratePersonToUser(mae1);
  }

  console.log("unable to update getDemoPatientODM for: " + patientID);
  return null;
};

export const loadDemoPractices = () => {
  return [siteOne, siteTwo];
};

export const getDemoPracticeODM = practiceID => {
  console.log("attempting to getDemoPracticeODM");
  if (practiceID === "siteOne") {
    return siteOne;
  }
  if (practiceID === "siteTwo") {
    return siteTwo;
  }

  console.log("unable to update getDemoPracticeODM for: " + practiceID);
  return null;
};

//#region DATA PATIENT DEFINITIONS
const linda1 = {
  user: {
    name: "Linda Ronstadt",
    birthdate: "1965-04-16",
    address: {
      streetAddress: "25 Ceife Key",
      locality: "Epegahuh",
      region: "WV",
      country: "USA",
      postalCode: "26047",
    },
    countryOfBirth: "US",
    email: "lindar@example.com",
    gender: "female",
    race: "white",
    ethnicity: "European",
    active: true,
    middleName: "",
    title: "",
    phone: "",
    familyName: "Ronstadt",
    givenName: "Linda",
  },
  personality: {
    avgInteractionsPerSession: 3.5,
    interactionDaysPerMonth: 30,
    favoriteAnimal: "cat",
    happyThoughts: ["grandchildren", "pets"],
    responseToAuthority: "Neutral reactance",
    riskProfile: "low",
    supportProfile: "low",
    accountabilityPartners: [
      {
        name: "Fred Brown",
        phone: "+15095551234",
        email: "demo@omnisciahealth.com",
        givenName: "Fred",
        ref: "A:Rz8KLP57V+Ah//UKRFoSiPil1E6gvJpVeTHC+l6SI+UGR0lXh2b/UJkT",
      },
    ],
  },
  clerical: {
    insuranceCarrier: "Premera",
    priorAuths: {
      GILENYA: {
        Premera: "not required",
      },
    },
    benefitInvestigation: "2021-01-08T00:00Z",
    disabilityStatus: "",
    employmentStatus: "",
    financialAssistance: false,
  },
  demo: {
    hardcoded: true,
  },
};

const linda2 = {
  user: {
    name: "Linda Hamilton",
    birthdate: "1965-07-19",
    address: {
      streetAddress: "761 Vahhah Lane",
      locality: "Ejigego",
      region: "SC",
      postalCode: "29446",
      country: "USA",
    },
    countryOfBirth: "US",
    phone: "+15093334567",
    email: "lindaH@example.com",
    gender: "female",
    race: "Black",
    ethnicity: "African",
    active: true,
    middleName: "",
    title: "",
    familyName: "Hamilton",
    givenName: "Linda",
  },
  personality: {
    favoriteAnimal: "horse",
    happyThoughts: ["nature", "the outdoors"],
    responseToAuthority: "Negative reactance",
    riskProfile: "low",
    supportProfile: "high",
    avgInteractionsPerSession: 4.4,
    interactionDaysPerMonth: 25,
    accountabilityPartners: [
      {
        name: "Fred Brown",
        phone: "+15095551234",
        email: "demo@omnisciahealth.com",
        givenName: "Fred",
        ref: "A:d/W95SPgV325jO6cZwYR/QO75zRg2N7V/cjtbN2N64QGR0lX3M6OvAT3",
      },
    ],
  },
  clerical: {
    benefitInvestigation: "2020-09-02T00:00Z",
    disabilityStatus: "",
    employmentStatus: "",
    financialAssistance: true,
    insuranceCarrier: "UHC",
  },
  demo: {
    hardcoded: true,
  },
};

const linda3 = {
  user: {
    name: "Lynda Carter",
    birthdate: "1965-09-30",
    address: {
      streetAddress: "641 Tukra Boulevard",
      locality: "Louzsil",
      region: "AR",
      country: "USA",
      postalCode: "71865",
    },
    countryOfBirth: "US",
    email: "lync@example.com",
    gender: "female",
    race: "white",
    ethnicity: "European",
    active: true,
    middleName: "",
    title: "",
    phone: "",
    familyName: "Carter",
    givenName: "Lynda",
  },
  personality: {
    happyThoughts: ["best friend"],
    favoriteAnimal: "dog",
    responseToAuthority: "Slightly positive reactance",
    riskProfile: "high",
    supportProfile: "high",
    avgInteractionsPerSession: 9.2,
    interactionDaysPerMonth: 10,
    accountabilityPartners: [
      {
        name: "Fred Brown",
        phone: "+15095551234",
        email: "demo@omnisciahealth.com",
        givenName: "Fred",
        ref: "A:iAej+JQaJDGkXrp6uxp06ILqVsAVmd8jnVFERNEgytQGR0lX3TsGGOcv",
      },
    ],
  },
  clerical: {
    benefitInvestigation: "2021-01-07T00:00Z",
    disabilityStatus: "",
    employmentStatus: "",
    financialAssistance: true,
    insuranceCarrier: "Aetna",
  },
  demo: {
    hardcoded: true,
  },
};

const mae1 = {
  user: {
    name: "Mae West",
    birthdate: "1972-06-14",
    address: {
      streetAddress: "25 Ceife Key",
      locality: "Epegahuh",
      region: "WV",
      country: "USA",
      postalCode: "26047",
    },
    countryOfBirth: "US",
    phone: "+15091234567",
    email: "maym@example.com",
    gender: "female",
    race: "Black",
    ethnicity: "African",
    active: true,
    middleName: "",
    title: "",
    familyName: "West",
    givenName: "Mae",
  },
  personality: {
    favoriteAnimal: "horse",
    happyThoughts: ["the outdoors", "nature"],
    responseToAuthority: "Negative reactance",
    riskProfile: "low",
    supportProfile: "high",
    avgInteractionsPerSession: 4.4,
    interactionDaysPerMonth: 25,
    accountabilityPartners: [
      {
        name: "Fred Brown",
        phone: "+15095551234",
        email: "demo@omnisciahealth.com",
        givenName: "Fred",
        ref: "A:iIjJJpwdp92I7V6zzxkf97E2Z8dMdPi0xp9/7fyjKp8GR0lXYdXKS73q",
      },
    ],
  },
  clerical: {
    insuranceCarrier: "Premera",
    disabilityStatus: "",
    employmentStatus: "Employee",
    financialAssistance: false,
    citizenship: "USA",
  },
  demo: {
    hardcoded: true,
  },
};

//#region DATA PATIENT DEFINITIONS
const siteOne = {
  _id: "siteOne",
  omniAudit: {},
  omniData: {
    name: "Tariq Medical Plaza",
    phone: "(555) 555-555",
    email: "fred@omnisciahealth.com",
    type: "Outpatient Care Facility",
    isActive: true,
    hours: [
      { days: "Mon-Thu", times: "8:00am - 5:00pm" },
      { days: "Fri", times: "8:00am - 2:00pm" },
      { days: "Sat-Sun", times: "CLOSED" },
    ],
    address: {
      streetAddress: "641 First Ave",
      locality: "Spokane",
      region: "WA",
      country: "USA",
      postalCode: "99216",
    },
    practiceManager: {
      name: "Dr. Tariq ",
      phone: "(555) 555-555",
      email: "fred@omnisciahealth.com",
    },
    providers: [
      {
        id: uuid(),
        name: "Dr. Tariq ",
        role: "Physician",
        email: "fred@omnisciahealth.com",
        phone: "(555) 555-555",
        note: "",
      },
      {
        id: uuid(),
        name: "Robert	Lewis",
        role: "Physician",
        email: "fred@omnisciahealth.com",
        phone: "(555) 555-555",
        note: "",
      },
      {
        id: uuid(),
        name: "Steven	Blake",
        role: "Physical Therapist",
        email: "fred@omnisciahealth.com",
        phone: "(555) 555-555",
        note: "",
      },
      {
        id: uuid(),
        name: "Audrey	King",
        role: "Case Manager",
        email: "fred@omnisciahealth.com",
        phone: "(555) 555-555",
        note: "",
      },
    ],
    patients: [
      {
        patientId: "linda1",
        name: "Linda Ronstadt",
        note: "Female, Age 56",
        trialId: 1,
      },
      {
        patientId: "linda2",
        name: "Linda Hamilton",
        note: "Female, Age 56",
        trialId: 0,
      },
      //Add more lindas or maes, split them in 3 sites
    ],
  },
};

const siteTwo = {
  _id: "siteTwo",
  omniAudit: {},
  omniData: {
    name: "Discount Dialysis",
    phone: "(555) 555-555",
    email: "fred@omnisciahealth.com",
    type: "Outpatient Care Facility",
    isActive: true,
    hours: [
      { days: "Mon-Thu", times: "8:00am - 4:00pm" },
      { days: "Fri-Sat", times: "8:00am - 1:00pm" },
      { days: "Sun", times: "CLOSED" },
    ],
    address: {
      streetAddress: "123 w. Main",
      locality: "Spokane",
      region: "WA",
      country: "USA",
      postalCode: "99216",
    },
    practiceManager: {
      name: "Dr. Krogh",
      phone: "(555) 555-555",
      email: "fred@omnisciahealth.com",
    },
    providers: [
      {
        id: uuid(),
        name: "Dr. Dre",
        role: "Physician",
        email: "fred@omnisciahealth.com",
        phone: "(555) 555-555",
        note: "",
      },
      {
        id: uuid(),
        name: "Dr. Zhivago",
        role: "Physician",
        email: "fred@omnisciahealth.com",
        phone: "(555) 555-555",
        note: "",
      },
      {
        id: uuid(),
        name: "Max Power",
        role: "Physical Therapist",
        email: "fred@omnisciahealth.com",
        phone: "(555) 555-555",
        note: "",
      },
      {
        id: uuid(),
        name: "Audrey	King",
        role: "Case Manager",
        email: "fred@omnisciahealth.com",
        phone: "(555) 555-555",
        note: "",
      },
    ],
    patients: [
      {
        patientId: "linda3",
        name: "Linda Carter",
        note: "Female, Age 56",
        trialId: 1,
      },
      {
        patientId: "linda2",
        name: "Mae West",
        note: "Female, Age 49",
        trialId: 0,
      },
      //Add more lindas or maes, split them in 3 sites
    ],
  },
};

//#endRegion
